module.exports = __webpack_public_path__ + "assets/photos/memories/frame-9-mobile--c82f1edd951e87c03e68b72a6c539389.jpg";